import { create } from 'zustand'
import { useShallow } from 'zustand/react/shallow'

interface HighlightState {
    highlightRequest: { id: string; className: string } | null
    requestHighlight: (id: string, className: string) => void
    clearHighlight: () => void
}

export const useHighlightStore = create<HighlightState>((set) => ({
    highlightRequest: null,
    requestHighlight: (id, className) =>
        set({ highlightRequest: { id, className } }),
    clearHighlight: () => set({ highlightRequest: null }),
}))

/**
 * A custom hook that retrieves a shallowly selected value from the `useHighlightStore` store.
 * Sample usage:
 * ```typescript
 * const { highlightRequest, requestHighlight } = useHighlightStoreShallowSelector((state) => ({
 *   highlightRequest: state.highlightRequest,
 *   requestHighlight: state.requestHighlight,
 * }));
 * ```
 *
 * @param selector - A function that takes the store state and returns the value to be selected.
 * @returns The selected value from the store.
 */
export const useHighlightStoreShallowSelector = <T>(
    selector: (state: HighlightState) => T
): T => useHighlightStore(useShallow(selector))
